import { connectedStore } from '../../store';
import actions from '../actions';

const synchronizeElement = (elementId) => {
  const store = connectedStore.get();
  store.dispatch(actions.synchronizeElement(elementId));
};

export default synchronizeElement;
